import ApiService from '@/services/Api.service';

class FeatureTogglesService {
  static async get(sponsorPlanId: number): Promise<Record<string, boolean>> {
    return ApiService.getJson(`/feature-toggle`, { sponsorPlanId });
  }
}

export default FeatureTogglesService;
